import type { AdminTypes } from '@inspiren-monorepo/virtual-care/api-contracts';

import { Api } from '../../../utility/client';

export const getBuildings = async () => {
  const res = await Api.get<AdminTypes.BuildingDto[]>('/admin/v1/buildings');
  return res.data;
};
